import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'qps';


export const QUALIFICATION_PACK_EMPTY_INFO_MESSAGE =
  'No qualification packs are available. They are created by the main organization admin or an awarding body user.';
export const getAllQualificationPacks = (params: { search?: string; limit?: number; skip?: number; orgId?: string; }) => {
  return axios.get(`${API_URL}/all`, { params });
};

export const getQualificationPackById = (id: string) => {
  return axios.get(`${API_URL}/`, { params: { id } });
};

export const createQualificationPack = (payload: any) => {
  return axios.post(`${API_URL}/`, payload);
};

export const updateQualificationPack = (id: string, payload: any) => {
  const body = {
    id,
    ...payload
  };

  return axios.put(`${API_URL}/`, body);
};

export const deleteQualificationPack = (id: string) => {
  return axios.delete(`${API_URL}/`, {
    data: { id }
  });
};
